/* ==========================================================================
   BENCH FITNESS - quote basket

   A gym owner specifying a fit-out needs to collect many machines and ask for
   one price, which is why the audit called the single Add to Cart button the
   site's biggest commercial gap. This keeps a client-side basket of items and
   submits them as one enquiry.

   Storage is localStorage, so no app subscription and no server. The submitted
   enquiry carries a formatted line-item list, so sales receive a complete
   specification in one email. If quotes later need to become Shopify draft
   orders, only the submit step changes.
   ========================================================================== */

window.BenchQuote = (function () {
  var KEY = 'bench_quote_v1';

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable, basket is session-only */
    }
    paint();
    document.dispatchEvent(new CustomEvent('bench:quote:change', { detail: { items: list } }));
  }

  function all() {
    return read();
  }

  function count() {
    return read().reduce(function (n, i) {
      return n + (parseInt(i.qty, 10) || 1);
    }, 0);
  }

  function add(item) {
    if (!item || !item.id) return;
    var list = read();
    var found = list.filter(function (i) {
      return String(i.id) === String(item.id);
    })[0];
    if (found) {
      found.qty = (parseInt(found.qty, 10) || 1) + (parseInt(item.qty, 10) || 1);
    } else {
      item.qty = parseInt(item.qty, 10) || 1;
      list.push(item);
    }
    write(list);
  }

  function remove(id) {
    write(
      read().filter(function (i) {
        return String(i.id) !== String(id);
      })
    );
  }

  function setQty(id, qty) {
    var q = parseInt(qty, 10);
    if (!q || q < 1) return remove(id);
    var list = read();
    list.forEach(function (i) {
      if (String(i.id) === String(id)) i.qty = q;
    });
    write(list);
  }

  function clear() {
    write([]);
  }

  /* Plain-text summary posted with the enquiry so sales get a full spec. */
  function asText() {
    return read()
      .map(function (i) {
        var name = i.title + (i.variant && i.variant !== 'Default Title' ? ' (' + i.variant + ')' : '');
        return i.qty + ' x ' + name + (i.sku ? ' [SKU ' + i.sku + ']' : '') + ' - ' + (i.url || '');
      })
      .join('\n');
  }

  function paint() {
    var n = count();

    document.querySelectorAll('[data-bench-quote-count]').forEach(function (el) {
      el.textContent = n;
    });

    document.querySelectorAll('[data-bench-quote-launcher]').forEach(function (el) {
      el.hidden = n === 0;
    });

    document.querySelectorAll('[data-bench-quote-empty]').forEach(function (el) {
      el.hidden = n !== 0;
    });

    document.querySelectorAll('[data-bench-quote-filled]').forEach(function (el) {
      el.hidden = n === 0;
    });

    var field = document.querySelector('[data-bench-quote-field]');
    if (field) field.value = asText();
  }

  /* Add to quote buttons carry their product data as a JSON payload. */
  function bind() {
    document.querySelectorAll('[data-bench-quote-add]').forEach(function (btn) {
      if (btn.dataset.benchBound) return;
      btn.dataset.benchBound = '1';
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        var payload;
        try {
          payload = JSON.parse(btn.getAttribute('data-bench-quote-add'));
        } catch (e) {
          return;
        }

        var qtyInput = btn.form ? btn.form.querySelector('input[name="quantity"]') : null;
        if (qtyInput) payload.qty = parseInt(qtyInput.value, 10) || 1;

        var variantInput = btn.form ? btn.form.querySelector('input[name="id"]') : null;
        if (variantInput) payload.id = variantInput.value;

        add(payload);

        var original = btn.getAttribute('data-bench-label-added');
        if (original) {
          var prev = btn.textContent;
          btn.textContent = original;
          btn.disabled = true;
          setTimeout(function () {
            btn.textContent = prev;
            btn.disabled = false;
          }, 1600);
        }
      });
    });

    document.querySelectorAll('[data-bench-quote-remove]').forEach(function (btn) {
      if (btn.dataset.benchBound) return;
      btn.dataset.benchBound = '1';
      btn.addEventListener('click', function () {
        remove(btn.getAttribute('data-bench-quote-remove'));
      });
    });

    document.querySelectorAll('[data-bench-quote-qty]').forEach(function (input) {
      if (input.dataset.benchBound) return;
      input.dataset.benchBound = '1';
      input.addEventListener('change', function () {
        setQty(input.getAttribute('data-bench-quote-qty'), input.value);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bind();
    paint();
  });

  return {
    add: add,
    remove: remove,
    setQty: setQty,
    all: all,
    count: count,
    clear: clear,
    asText: asText,
    refresh: function () {
      bind();
      paint();
    }
  };
})();
